__turbopack_context__.v({
  "DM_12_24_Link_B": "GeneralMessage-module-scss-module__-oGykq__DM_12_24_Link_B",
  "DM_14_24_Link_B": "GeneralMessage-module-scss-module__-oGykq__DM_14_24_Link_B",
  "DM_20_24_Bold": "GeneralMessage-module-scss-module__-oGykq__DM_20_24_Bold",
  "DM_Body_Reg_16": "GeneralMessage-module-scss-module__-oGykq__DM_Body_Reg_16",
  "DM_Bold_14_16": "GeneralMessage-module-scss-module__-oGykq__DM_Bold_14_16",
  "DM_Bold_14_24_UC": "GeneralMessage-module-scss-module__-oGykq__DM_Bold_14_24_UC",
  "DM_Bold_16_24": "GeneralMessage-module-scss-module__-oGykq__DM_Bold_16_24",
  "DM_Bold_20_24": "GeneralMessage-module-scss-module__-oGykq__DM_Bold_20_24",
  "DM_Bold_40_56": "GeneralMessage-module-scss-module__-oGykq__DM_Bold_40_56",
  "DM_Btn_16_16_Med": "GeneralMessage-module-scss-module__-oGykq__DM_Btn_16_16_Med",
  "DM_Med_10_12": "GeneralMessage-module-scss-module__-oGykq__DM_Med_10_12",
  "DM_Med_12_12_Chip": "GeneralMessage-module-scss-module__-oGykq__DM_Med_12_12_Chip",
  "DM_Med_12_16": "GeneralMessage-module-scss-module__-oGykq__DM_Med_12_16",
  "DM_Med_14_16": "GeneralMessage-module-scss-module__-oGykq__DM_Med_14_16",
  "DM_Med_14_20": "GeneralMessage-module-scss-module__-oGykq__DM_Med_14_20",
  "DM_Med_14_24": "GeneralMessage-module-scss-module__-oGykq__DM_Med_14_24",
  "DM_Med_16_16": "GeneralMessage-module-scss-module__-oGykq__DM_Med_16_16",
  "DM_Med_16_24": "GeneralMessage-module-scss-module__-oGykq__DM_Med_16_24",
  "DM_Med_18_24": "GeneralMessage-module-scss-module__-oGykq__DM_Med_18_24",
  "DM_Med_20_24": "GeneralMessage-module-scss-module__-oGykq__DM_Med_20_24",
  "DM_Med_24_24": "GeneralMessage-module-scss-module__-oGykq__DM_Med_24_24",
  "DM_Med_32_32": "GeneralMessage-module-scss-module__-oGykq__DM_Med_32_32",
  "DM_Med_32_48": "GeneralMessage-module-scss-module__-oGykq__DM_Med_32_48",
  "DM_Med_8_8": "GeneralMessage-module-scss-module__-oGykq__DM_Med_8_8",
  "DM_Reg_10_10": "GeneralMessage-module-scss-module__-oGykq__DM_Reg_10_10",
  "DM_Reg_12_12_Chip": "GeneralMessage-module-scss-module__-oGykq__DM_Reg_12_12_Chip",
  "DM_Reg_12_16": "GeneralMessage-module-scss-module__-oGykq__DM_Reg_12_16",
  "DM_Reg_14_16": "GeneralMessage-module-scss-module__-oGykq__DM_Reg_14_16",
  "DM_Reg_14_24": "GeneralMessage-module-scss-module__-oGykq__DM_Reg_14_24",
  "DM_Reg_14_32_Table": "GeneralMessage-module-scss-module__-oGykq__DM_Reg_14_32_Table",
  "DM_Reg_16_16_Chip": "GeneralMessage-module-scss-module__-oGykq__DM_Reg_16_16_Chip",
  "DM_Reg_16_20": "GeneralMessage-module-scss-module__-oGykq__DM_Reg_16_20",
  "DM_Reg_16_24": "GeneralMessage-module-scss-module__-oGykq__DM_Reg_16_24",
  "DM_Reg_16_24_Italic": "GeneralMessage-module-scss-module__-oGykq__DM_Reg_16_24_Italic",
  "DM_Reg_18_28": "GeneralMessage-module-scss-module__-oGykq__DM_Reg_18_28",
  "DM_Reg_32_32": "GeneralMessage-module-scss-module__-oGykq__DM_Reg_32_32",
  "DM_Reg_40_56": "GeneralMessage-module-scss-module__-oGykq__DM_Reg_40_56",
  "columnLayout": "GeneralMessage-module-scss-module__-oGykq__columnLayout",
  "container": "GeneralMessage-module-scss-module__-oGykq__container",
  "description": "GeneralMessage-module-scss-module__-oGykq__description",
  "error": "GeneralMessage-module-scss-module__-oGykq__error",
  "fullWidth": "GeneralMessage-module-scss-module__-oGykq__fullWidth",
  "icon": "GeneralMessage-module-scss-module__-oGykq__icon",
  "messageContainer": "GeneralMessage-module-scss-module__-oGykq__messageContainer",
  "small": "GeneralMessage-module-scss-module__-oGykq__small",
  "title": "GeneralMessage-module-scss-module__-oGykq__title",
  "warning": "GeneralMessage-module-scss-module__-oGykq__warning",
});
